<template>
  <div class="container">
    <div class="doc__content">
      <div>
        <h2>1. General</h2>
        <p>
          These are the terms of use and services (“Terms”) of Carsome Sdn Bhd
          (Company No: 1101954-M). The access to and use of the services on this
          website (“the Website”) are subject to these Terms.
        </p>
        <p>
          Carsome provides an online automotive platform that allows the
          prospective buyers to research, compare, bid and purchase vehicle(s)
          listed on the Website.
        </p>
        <p>
          By accessing and using the Website, you agree to comply with and be
          bound by these Terms which shall be applicable to all Users of the
          Website. If you are using and accessing the Website for and on behalf
          of a business entity, the term “you” in these Terms shall mean the
          business entity in which you are representing in using the Website,
          unless the context does not permit.
        </p>
        <p>
          You are advised to read these Terms carefully as these affect your
          rights and liabilities under applicable laws and regulations in
          Malaysia. If you do not agree to these Terms, you should not use the
          Website.
        </p>
        <h2>2. Right to use and restrictions</h2>
        <ul class="sub">
          <li>
            <p>
              2.1.&nbsp;You are responsible for the access to and use of the
              Website, including obtaining the necessary data network access,
              even if the access is by another person.
            </p>
          </li>
          <li>
            <p>
              2.2.&nbsp;You are accessing and using the Website at your own
              risk. We shall not be liable for any damage to, or viruses or
              other codes that may affect any hardware or device, software, data
              or other property as a result of your access to and use of the
              Website.
            </p>
          </li>
          <li>
            <p>
              2.3.&nbsp;You may only access the Website using authorised means.
              It is your responsibility to check and ensure that you have
              downloaded and/or updated the correct software for the hardware
              and device for your access to and use of the Website. We do not
              guarantee that the Website, or any part thereof, will function as
              intended on any particular hardware or device. We are not liable
              if you do not have compatible hardware or a compatible device or
              if you have downloaded the wrong version of the software on your
              hardware or device.
            </p>
          </li>
          <li>
            <p>
              2.4.&nbsp;You shall access and use the Website in accordance with
              any instructions for access to and use of the Website which we may
              make from time to time, these Terms and regulations at the time
              being in force in Malaysia.
            </p>
          </li>
          <li><p>2.5.&nbsp;You shall not:</p></li>
          <li class="sub">
            <ul>
              <li>
                <p>
                  (a) impersonate any person or party or falsely declare,
                  distort or misrepresent your affiliation with any person or
                  party in connection with the Website, or express or imply that
                  we endorse any statement you make;
                </p>
              </li>
              <li>
                <p>
                  (b) in any way damage or disrupt the Website and/or the
                  operation of the Website;
                </p>
              </li>
              <li>
                <p>
                  (c) use the Website for any fraudulent, unauthorised or
                  unlawful purpose;
                </p>
              </li>
              <li>
                <p>
                  (d) deliberately and knowingly provide information or content
                  that is false, misleading, inaccurate, illegal, threatening,
                  obscene, hateful, libellous or defamatory;
                </p>
              </li>
              <li>
                <p>
                  (e) use the Website in a manner that may be contrary to our
                  interests and/or the interest of other Users;
                </p>
              </li>
              <li>
                <p>
                  (f) introduce or allow the introduction of computer viruses
                  and/or other computer programming routines such as any
                  viruses, malware, unsolicited e-mails, Trojan horses, trap
                  doors, back doors, worms, time bombs or cancelbots that may
                  damage, detrimentally interfere with, surreptitiously
                  intercept or expropriate any system, data or personal
                  information, relating to or in connection with the Website;
                </p>
              </li>
              <li>
                <p>
                  (g) reproduce, duplicate, copy, sell, resell or otherwise
                  exploit for any commercial purposes, any portion of, use of,
                  or access to the Website;
                </p>
              </li>
              <li>
                <p>
                  (h) use the Website in a manner that is in breach of any laws
                  and regulations in Malaysia.
                </p>
              </li>
            </ul>
          </li>
          <li><p>2.6.&nbsp;We reserve the right to:</p></li>
          <li class="sub">
            <ul>
              <li>
                <p>
                  (a) check, vet and/or control any activity, content or
                  information occurring on or through the Website;
                </p>
              </li>
              <li>
                <p>
                  (b) investigate any infringement of these Terms and take any
                  appropriate action thereafter;
                </p>
              </li>
              <li>
                <p>
                  (c) restrict your access to and use of the Website if you
                  violate any of the items stated in Clause 2.5 above; and/or
                </p>
              </li>
              <li>
                <p>
                  (d) report any suspicious activity concerning the possible
                  transgression of any applicable law or regulation to the
                  appropriate authorities and to cooperate with such
                  authorities.
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <h2>3. Warranties and Limitation of Liability</h2>
        <ul class="sub">
          <li>
            <p>
              3.1.&nbsp;Prospective buyers are advised to read and understand
              the terms and conditions of the sale and to inspect the vehicles
              listed and conduct and rely on their own searches, enquiries,
              investigations and verifications on the accuracy and correctness
              of the particulars and information provided on the Website prior
              to purchasing.
            </p>
          </li>
          <li>
            <p>
              3.2.&nbsp;All prospective buyers should also note that any
              vehicle(s) listed as available for sale herein is subject to terms
              and conditions of sale and that any of the above vehicle(s) may at
              anytime be withdrawn from the listing in the Website absolute
              discretion without any prior notice being given and for any reason
              whatsoever. The decision of the Website in relation to the
              proposed sale is final and shall not subject to challenge. Neither
              shall we, the Website nor its Agents be held liable for the
              contents herein in any manner whatsoever under any circumstances
              including but not limited to withdrawal of vehicle(s) from the
              sale.
            </p>
          </li>
          <li>
            <p>
              3.3.&nbsp;We may modify or discontinue the Website or any of the
              services or features of the Website, including specific listings,
              with or without notice, without liability to you, any other user
              or any third party for any reason. You understand and agree that
              the Site and its services are provided on an "AS AVAILABLE" basis.
              Carsome assumes no responsibility for the timeliness, deletion,
              mis-delivery of or failure to store any user communications.
            </p>
          </li>
        </ul>
        <h2>4. Personal data</h2>
        <p>
          Our Personal Data Protection Notice governs the use of any personal
          information that you provide to us via the Website. A copy of the
          Personal Data Protection Notice can be accessed here at the Website.
        </p>
        <p></p>
        <h2>5. Disclaimer</h2>
        <p>
          We shall not be liable for any damages whatsoever, including but
          without limitation to any direct, indirect, special, consequential,
          punitive or incidental damages, or damages for loss of use, profits,
          data or other intangibles, damage to goodwill or reputation, arising
          out of or related to the use, inability to use or failures of the
          Website. We expressly disclaim any express and implied warranties,
          including, without limitation, completeness or accuracy of any
          information provided or made available to you. We do not warrant that
          the Website and any and all of its related facilities or capabilities
          will be free of interruption or error, that defects will be corrected,
          or that the equipment and software that makes the Website available is
          free of viruses or other harmful components.
        </p>
      </div>
    </div>
  </div>
</template>


<style scoped>
.container {
  padding:0px 16px 16px 16px ;
  width: 100%;
  box-sizing: border-box;
}

p {
  margin-top: 8px;
  text-align: start;
  font-size: 4px;
  font-weight: 400;
  font-family: Roboto;
  font-style: normal;
  color: #696c71;
}

h2 {
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  font-family: Roboto;
  font-style: normal;
  color: #2e2e2e;
  margin-top: 24px;
  font-weight: 700;
}

.sub {
  padding-left: 12px;
}
</style>
